module.exports = __webpack_public_path__ + "static/media/bell.dd3ac01d.svg";